import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DataListConfig} from '@shared/module/data-list/component/data-list/data-list.config';
import {PayloadInterface} from '@shared/model';

@Component({
  selector: 'app-data-detail',
  templateUrl: './data-detail.component.html',
  styleUrls: ['./data-detail.component.scss']
})
export class DataDetailComponent {
  @Input() detail!: any;
  @Input() config!: DataListConfig;

  @Input() translateKey = '';
  @Output() filterChange = new EventEmitter<PayloadInterface>();
}
